const borders = {
    innerInputElementBorder: "#ccc 1px solid",
    containerInputElementBorder: "#eee 1px solid",
    smallBorderRadius: "4px",
    mediumBorderRadius: "8px",
    largeBorderRadius: "16px"
}
export default borders